// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1c-ea","productName":"Table_productName__bxh_3"};